export default {
      id: "twitter-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite.svg#twitter",
      toString: function () {
        return this.url;
      }
    }